/**
 * Constants definition.
 *
 * @type {{SINGLE: string, MARRIED: string}}
 */
const CIVIL_STATUS = {
  MARRIED: 'MARRIED',
  SINGLE: 'SINGLE',
  DIVORCED: 'DIVORCED',
  WIDOWER: 'WIDOWER',
};

/**
 * Enum definition.
 *
 * @type {string[]}
 */
const CIVIL_STATUS_ENUM = Object.keys(CIVIL_STATUS);

const MARRIED = CIVIL_STATUS_ENUM[0];
const SINGLE = CIVIL_STATUS_ENUM[1];
const DIVORCED = CIVIL_STATUS_ENUM[2];
const WIDOWER = CIVIL_STATUS_ENUM[3];

export {
  SINGLE,
  MARRIED,
  DIVORCED,
  WIDOWER,
  CIVIL_STATUS_ENUM,
  CIVIL_STATUS,
};
